import { Platform, StyleSheet } from "react-native";
import colors from "../../../constants/colors";

export const TEXT_STYLES = StyleSheet.create({
  middle: {
    fontSize: 20,
    color: "white",
  },
  camera: {
    flex: 8,
    width: "100%",
    minHeight: 0,
  },
  cameraLeftOptionsContainer: {
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: colors.primary,
    width: "100%",
    height: Platform.OS === "ios" ? "10%" : "8%",
    position: "absolute",
    top: 0,
    zIndex: 1,
  },
  switchCameraButton: {
    borderRadius: 50,
    color: "white",
    marginTop: Platform.OS === "ios" ? 50 : 20,
    marginLeft: 10,
  },
});
